'use strict';
/* global $BV */
import jsonPageData from 'helpers/json-page-data'
import delay from 'helpers/delay'
import Events from 'events/events'

function initBazaarVoice() {
  $BV.configure('global', {});
  $BV.ui('rr', 'show_reviews', buildBazaarVoiceRequest());
}

let BV_intervlId;


function isBVAvailable() {
  if (typeof window.$BV !== 'undefined') {
    clearInterval(BV_intervlId)
    initBazaarVoice();
    Events.reviewsReinit.register(initBazaarVoice);
  }
}
function buildBazaarVoiceRequest() {
  return {
    productId: jsonPageData.getData().productId,
    onEvent: function (event) {
      handleBazaarVoiceEvent(event)
    }
  };
}

function handleBazaarVoiceEvent(event) {
  if (bazaarVoiceSectionHasLoaded(event)) {
    showReviewsAccordion();
    sendAccordionContentUpdatedEvent();
  }
  if (bazaarVoiceSectionHasUpdated(event)) {
    sendAccordionContentUpdatedEvent();
  }
  bazaarVoicePhotosExist();
}

function bazaarVoicePhotosExist() {
  let checkPhoto;
  if (window.bvCurationsCount == undefined) {
    checkPhoto = setTimeout(function () {
      bazaarVoicePhotosExist();
    }, 250);
  } else {
    clearTimeout(checkPhoto);
    if (window.bvCurationsCount >= 1) {
      document.body.dispatchEvent(
        new CustomEvent('dataStateChange', {
          detail: {
            action: 'Bvcurations.enabled'
          }
        })
      );
      showPhotosAccordion();
    }
  }
}

let windowWidth = window.innerWidth;
let photoAccordion = getCustomerPhotosAccordion()
if (photoAccordion) {
  photoAccordion.addEventListener('click', function () {
    let content = photoAccordion.querySelector('.product-detail__content--photos');
    if (!content.getAttribute('style') == '') {
      setTimeout(function () {
        if (windowWidth < 768) {
          window.BVWidgets.reset({ cols: '2' });
        } else {
          window.BVWidgets.reset();
        }
      }, 1);
    }
  });
}

function getCustomerPhotosAccordion() {
  return document.querySelector('.product-detail--photos');
}

function showPhotosAccordion() {
  getCustomerPhotosAccordion().classList.remove('u-hidden');
}

function getReviewsAccordion() {
  return document.querySelector('.product-detail--reviews');
}

function showReviewsAccordion() {
  getReviewsAccordion().classList.remove('u-hidden');
}

function bazaarVoiceSectionHasUpdated(event) {
  return event.eventSource == "Action";
}

function bazaarVoiceSectionHasLoaded(event) {
  return event.eventSource == "Display" && event.eType == "Read";
}

function sendAccordionContentUpdatedEvent() {
  delay(0, () => {
    Events.accordionContentUpdated.trigger(getReviewsAccordion(), null);
  });
}

function listenForCookiePreferences() {
  document.body.addEventListener('jl-privacy:cookiePreferences', (event) => {
    const payload = event.detail
    const canDropScript = (payload && payload.JOHNLEWIS_ENSIGHTEN_PRIVACY_FUNCTIONAL === '1')
    if (canDropScript) {
      const containerElement = document.getElementById('BVRRSummaryContainer');
      // eslint-disable-next-line no-console
      console.log('BV containerElement', containerElement);
      if (!containerElement) {
        return;
      }

      try {
        const bvScript = document.createElement('script');
        bvScript.src = 'https://johnlewis.ugc.bazaarvoice.com/bvstaging/static/7051-en_gb/bvapi.js';
        bvScript.onload = () => {
          isBVAvailable();
          Events.reviewsReinit.trigger();
          // Check twice to see if the BV container has content
          let checkBvCount = 0;
          let checkBvInterval
          function checkBvContainer() {
            const element = document.getElementById('BVRRRatingSummaryLinkReadID');
            if (!element) {
              if (checkBvCount === 1) {
                clearInterval(checkBvInterval);
                location.reload();
                return;
              }
              checkBvCount += 1;
            }
          }

          checkBvInterval = setInterval(() => {
            checkBvContainer();
          }, 500);
        };
        document.body.append(bvScript)
      } catch (error) {
        console.error(({ error }));
        location.reload();
      }
    }
  })
}

if ('querySelector' in document && getReviewsAccordion()) {
  BV_intervlId = setInterval(isBVAvailable, 500)
  listenForCookiePreferences();
}
